module.exports = __webpack_public_path__ + "img/room_2.0805931b.jpg";